"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.btnPropTypes = exports.wrapperPropTypes = exports.tertiaryBtnPropTypes = exports.iconBtnPropTypes = exports.commonPropTypes = exports.wrapperDefaults = exports.linkBtnDefaults = exports.tertiaryBtnDefaults = exports.secondaryBtnDefaults = exports.primaryBtnDefault = exports.commonButtonDefaults = exports.commonDefaults = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* default props */
var commonDefaults = {
  atts: {},
  ariaDescribedBy: null,
  doFocus: false,
  disabled: false,
  onClick: function onClick() {}
};
exports.commonDefaults = commonDefaults;

var commonButtonDefaults = _objectSpread({}, commonDefaults, {
  isSmall: false
});

exports.commonButtonDefaults = commonButtonDefaults;

var primaryBtnDefault = _objectSpread({
  type: 'submit'
}, commonButtonDefaults);

exports.primaryBtnDefault = primaryBtnDefault;

var secondaryBtnDefaults = _objectSpread({
  type: 'button'
}, commonDefaults);

exports.secondaryBtnDefaults = secondaryBtnDefaults;

var tertiaryBtnDefaults = _objectSpread({
  type: 'button',
  icon: null,
  isLeftAligned: false,
  isInline: false
}, commonDefaults);

exports.tertiaryBtnDefaults = tertiaryBtnDefaults;

var linkBtnDefaults = _objectSpread({}, commonDefaults, {
  children: null,
  cssClass: '',
  isCentered: true
});

exports.linkBtnDefaults = linkBtnDefaults;

var wrapperDefaults = _objectSpread({
  type: 'button',
  children: null,
  cssClass: '',
  ariaLabel: ''
}, commonDefaults);
/* propTypes */


exports.wrapperDefaults = wrapperDefaults;
var commonPropTypes = {
  atts: _propTypes.default.object,

  /* optional html attrs */
  type: _propTypes.default.oneOf([
  /* html type */
  'button', 'submit']),
  ariaDescribedBy: _propTypes.default.string,
  doFocus: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func.isRequired,
  cashbotName: _propTypes.default.string.isRequired
};
exports.commonPropTypes = commonPropTypes;

var iconBtnPropTypes = _objectSpread({}, commonPropTypes, {
  ariaLabel: _propTypes.default.string.isRequired,
  cssClass: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node.isRequired
});

exports.iconBtnPropTypes = iconBtnPropTypes;

var tertiaryBtnPropTypes = _objectSpread({}, commonPropTypes, {
  btnText: _propTypes.default.string.isRequired,
  isLeftAligned: _propTypes.default.bool,
  isInline: _propTypes.default.bool,
  icon: _propTypes.default.node
});

exports.tertiaryBtnPropTypes = tertiaryBtnPropTypes;

var wrapperPropTypes = _objectSpread({}, commonPropTypes, {
  ariaLabel: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  cssClass: _propTypes.default.string.isRequired
});

exports.wrapperPropTypes = wrapperPropTypes;

var btnPropTypes = _objectSpread({}, commonPropTypes, {
  btnText: _propTypes.default.string.isRequired,
  isSmall: _propTypes.default.bool
});

exports.btnPropTypes = btnPropTypes;